import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import { HashRouter as Router, Route, Switch } from "react-router-dom";
import { Container, Modal, Button } from "react-bootstrap";
import Header from "./Header";
import Logout from "./Logout";
import { Trans, withTranslation } from 'react-i18next';

import Welcome from "./welcome/Welcome";
import ProjectsCloudList from "./projects/ProjectsCloudList";
import UploadFile from "./projects/upload";
import Project from "./projects/Project";
import ErrorsContainer from "../shared/ErrorsContainer";
import CreateProjectFromUrl from "./projects/createProjectFromUrl";

import { fetchBrand, fetchHeaderWarning } from "../../actions/index";

import { X_API_KEY } from "../../utils/authentication";

// import NavigationPrompt from '../shared/NavigationPrompt';
import Handler from "../shared/Handler";

export const AppTitle = "T4T Field NT Internal";

class App extends React.Component {
    constructor(props) {
        super(props);
        this.contentRef = React.createRef();

        this.state = {
            isShowingLogoutPopup: false,
        };

        this.handleOpenLogoutPopup = this.handleOpenLogoutPopup.bind(this);
    }

    componentDidMount() {
        this.props.fetchBrand();
        this.props.fetchHeaderWarning();
    }

    componentDidUpdate() {
    // const { style } = this.contentRef.current;
        const { style } = document.body;
        if (this.props.brand.name) {
            switch (this.props.brand.name) {
                case "BRAND_TCI":
                    style.setProperty("--brand-color1", "#2794db");
                    style.setProperty("--brand-color2", "#2794db");
                    break;
                case "BRAND_VLSCH":
                    style.setProperty("--brand-color1", "#E95B0D");
                    style.setProperty("--brand-color2", "#FF6600");
                    break;
                case "BRAND_PG":
                    style.setProperty("--brand-color1", "#45CAE6");
                    style.setProperty("--brand-color2", "#666466");
                    break;
                default:
                    style.setProperty("--brand-color1", "#E95B0D");
                    style.setProperty("--brand-color2", "#FF6600");
            }
        } else {
            style.setProperty("--brand-color1", "#E95B0D");
            style.setProperty("--brand-color2", "#FF6600");
        }
    }

    componentWillUnmount() {
        const { style } = document.body;
        style.removeProperty("--brand-color1");
        style.removeProperty("--brand-color2");
    }

    handleOpenLogoutPopup() {
        let apiKey = localStorage.getItem(X_API_KEY);
        if (apiKey && apiKey.length > 0) {
            this.setState({ isShowingLogoutPopup: true });
        } else {
            this.setState({ isShowingLogoutPopup: false }, this.props.history.push("/logout"));
        }
    }

    handleCloseLogoutPopup(result) {
        let brandParam = "";

        if (this.props.brand) {
            brandParam = "?brand=" + this.props.brand.name;
        }

        if (!result) {
            this.setState({ isShowingLogoutPopup: false });
        } else {
            this.setState(
                { isShowingLogoutPopup: false },
                this.props.history.push(`/logout${brandParam}`)
            );
        }
    }

    render() {
        if (this.props.brand.name === undefined) {
            return null;
        }

        return (
            <Router>
                <Handler>
                    <div>
                        <Header
                            handleOpenLogoutPopup={this.handleOpenLogoutPopup}
                            brandName={this.props.brand.name}
                            warning={this.props.headerWarning}
                        />
                    </div>
                    <div ref={this.contentRef} className="content">
                        <Container fluid="true" className="internal-content">
                            <Switch>
                                <Route exact path="/" render={() => <Welcome brandName={this.props.brand.name} />} />
                                <Route path="/welcome" render={() => <Welcome brandName={this.props.brand.name} />} />
                                <Route path="/logout" component={Logout} />

                                <Route path="/projects/:id" component={Project} />

                                <Route path="/projects" component={ProjectsCloudList} />
                                <Route path="/projects" component={ProjectsCloudList} />
                                <Route path="/upload/" component={UploadFile} />
                                <Route path="/projectsOnCloud" component={ProjectsCloudList} />
                                <Route path="/createProject" component={Project} />
                                <Route path="/createProjectlife" component={CreateProjectFromUrl} />
                            </Switch>
                        </Container>

                        <ErrorsContainer />

                        <Modal
                            show={this.state.isShowingLogoutPopup}
                            onHide={() => this.handleCloseLogoutPopup(false)}
                            animation={false}
                        >
                            <Modal.Header closeButton>
                                <Modal.Title style={{ color: "#E95B0D" }}><Trans i18nKey="Confirmation" /></Modal.Title>
                            </Modal.Header>

                            <Modal.Body>
                                <p>
                                    <Trans i18nKey="Logout_Access_Key_Warning" />
                                </p>
                            </Modal.Body>

                            <Modal.Footer>
                                <Button
                                    variant="primary"
                                    style={{ marginRight: "0" }}
                                    onClick={() => this.handleCloseLogoutPopup(true)}
                                >
                                    <Trans i18nKey="Continue_anyways" />
                                </Button>
                                <Button variant="secondary" onClick={() => this.handleCloseLogoutPopup(false)}>
                                    <Trans i18nKey="Cancel" />
                                </Button>
                            </Modal.Footer>
                        </Modal>
                    </div>
                </Handler>
            </Router>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        errors: state.errorsHandler.errors,
        notFound: state.errorsHandler.notFound,
        brand: state.brand,
        headerWarning: state.headerWarning,
    };
};

const mapDispatchToProps = {
    fetchBrand,
    fetchHeaderWarning,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(App)));
